import React from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';
import { scrollToAnchor } from 'base/utils/scrollTo';
import { useTrans } from 'base/utils/i18n'

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const Title: React.FC = () => {
    const { t } = useTrans();

    const goHelp = () => {
        scrollToAnchor({
            selector: '#js-early-access-rules',
        });
    }

    return (
        <div
            className={cn(
                styles['title-wrap'],
                !isPhone && 'text-center'
            )}
        >
            <h3 className={styles.title}>{t('web_shop_activity_early_access_title')}</h3>

            {!isPhone && (
                <div className={styles.help}>
                    {t('web_shop_activity_early_access_learn_about')}
                    <Iconfont onClick={goHelp} className={'icon-help'}/>
                </div>
            )}

            <p className={styles.msg}>
                {t('web_shop_activity_early_access_desc')}
            </p>
        </div>
    );
};

export default Title